export const FETCH_SMS_DETAILS = 'FETCH_SMS_DETAILS'
export const LOAD_SMS_DETAILS = 'LOAD_SMS_DETAILS'
export const FETCH_SMS_MEMBERS_SUBSCRIBED = 'FETCH_SMS_MEMBERS_SUBSCRIBED'
export const LOAD_SMS_MEMBERS_SUBSCRIBED = 'LOAD_SMS_MEMBERS_SUBSCRIBED'
export const FETCH_SMS_MEMBERS_UNSUBSCRIBED = 'FETCH_SMS_MEMBERS_UNSUBSCRIBED'
export const LOAD_SMS_MEMBERS_UNSUBSCRIBED = 'LOAD_SMS_MEMBERS_UNSUBSCRIBED'
export const FETCH_SMS_USER = 'FETCH_SMS_USER'
export const FETCH_SMS_HISTORY = 'FETCH_SMS_HISTORY'
export const LOAD_SMS_USER = 'LOAD_SMS_USER'
export const LOAD_SMS_HISTORY = 'LOAD_SMS_HISTORY'
export const RESET_SMS_DETAILS = 'RESET_SMS_DETAILS'
export const RESET_SMS_MEMBERS_SUBSCRIBED = 'RESET_SMS_MEMBERS_SUBSCRIBED'
export const RESET_SMS_MEMBERS_UNSUBSCRIBED = 'RESET_SMS_MEMBERS_UNSUBSCRIBED'

export function fetchSmsDetails (id) {
  const query = { alertId: id }
  return { type: FETCH_SMS_DETAILS, query }
}

export function loadSmsDetails (data) {
  return { type: LOAD_SMS_DETAILS, data }
}

export function resetSmsDetails () {
  return { type: RESET_SMS_DETAILS }
}

export function fetchSmsMembers (id, subscribed, options) {
  const query = { alertId: id, subscribed }
  query.limit = options.limit ?? 5
  query.offset = options.offset ?? 0

  const type = subscribed ? FETCH_SMS_MEMBERS_SUBSCRIBED : FETCH_SMS_MEMBERS_UNSUBSCRIBED
  return { type, query }
}

export function loadSmsMembers (data, type) {
  const eventType = type === FETCH_SMS_MEMBERS_SUBSCRIBED
    ? LOAD_SMS_MEMBERS_SUBSCRIBED
    : LOAD_SMS_MEMBERS_UNSUBSCRIBED
  return { type: eventType, data }
}

export function resetSmsMembersSubscribed () {
  return { type: RESET_SMS_MEMBERS_SUBSCRIBED }
}

export function resetSmsMembersUnsubscribed () {
  return { type: RESET_SMS_MEMBERS_UNSUBSCRIBED }
}

/**
 * fetchSmsUser
 * @desc generate fetch sms user action generator
 * @param {string} ID accountId
 * @param {string} memberId user ID
 * @return {action} fetchSmsUserActions
 */
export function fetchSmsUser (ID, memberId) {
  const query = { accountId: ID, memberId }
  return { type: FETCH_SMS_USER, query }
}

/**
 * fetchSmsHistory
 * @param {string} ID
 * @param {string} memberId
 * @param {timestamp} start
 * @param {timestamp} end
 * @param {Object} options
 * @return {action} fetchSmsHistoryAction
 */
export function fetchSmsHistory (ID, memberId, start, end, options) {
  const query = { accountId: ID, memberId, startDate: start, endDate: end }
  if (options.sourceType) {
    query.sourceType = options.sourceType
  } else {
    query.sourceType = 'ALL'
  }
  if (options.limit) {
    query.limit = options.limit
  }
  if (options.offset) {
    query.offset = options.offset
  } else query.offset = 0

  return { type: FETCH_SMS_HISTORY, query }
}

/**
 * loadSmsUser
 * @desc Load Sms User Action Generator
 * @param {Object} data data to be loaded
 *@return {action} LoadSmsUserAction
 */
export function loadSmsUser (data) {
  return { type: LOAD_SMS_USER, data }
}

/**
 * loadSmsHistory
 * @desc Load Sms History Action Generator
 * @param {Object} data data to be loaded
 *@return {action} LoadSmsHistoryAction
 */
export function loadSmsHistory (data) {
  return { type: LOAD_SMS_HISTORY, data }
}
